let mapModeState = $state('normal'); // 'normal' | 'tech'

export const techMode = {
  get mapMode() { return mapModeState; },
  setNormal() { mapModeState = 'normal'; },
  setTech() { mapModeState = 'tech'; }
};
